module.exports = "/assets/cola-page/hero.png?GWm7KnW";